import React from 'react'
import { navigate } from 'gatsby'
import EVENTS from '../../utils/events'
import SearchGroupHeading from './components/SearchGroupHeading'
import ContainerDivider from './components/ContainerDivider'
import IconCloseClear from './components/IconCloseClear'
import MagnifyingGlass from './components/MagnifyingGlass'
import SearchInput from './components/SearchInput'
import SearchResults from './components/SearchResults'
import SearchResult from './components/SearchResult'
import {
  Feedback,
  Loading,
  Spinner,
  ErrorFeedback
} from './components/Feedback'
import ViewAllResultsButton from './components/ViewAllResultsButton'
import searchFn from '../../state/search/lib/search'
import { trackEvent } from '../../../lib/tracker'

class HeaderOmniSearch extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hidden: true,
      results: this.props.results,
      loading: false,
      error: null
    }
    this.onChange = this.onChange.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
    this.onClearInput = this.onClearInput.bind(this)
    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onSearchItemClick = this.onSearchItemClick.bind(this)
    this.onAllResultsClick = this.onAllResultsClick.bind(this)
  }

  onMouseEnter(e) {
    e.target.focus()
  }

  hideResults() {
    this.setState({ hidden: true, results: [] })
    window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
  }

  onSearchItemClick() {
    this.onClearInput()
  }

  onAllResultsClick() {
    trackEvent('Search', 'View All', '', '', {
      search_term: this.props.searchTerm
    })
    this.props.setCurrentSearchTerm(this.props.searchTerm)
    this.hideResults()
    navigate(`/search/?term=${this.props.searchTerm}`)
  }

  async onChange(e) {
    const phrase = e.target.value
    if (typeof window !== 'undefined') {
      if (phrase.length >= 3) {
        window.dispatchEvent(
          new CustomEvent(EVENTS.CONTENT.DIMMER_ON, {
            detail: EVENTS.CTRL.PRIMARY
          })
        )
      } else {
        window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
      }
    }
    if (phrase.length >= 1) {
      this.props.setSearchTerms(phrase)
      this.setState({ hidden: false, searchTerm: phrase })
      const loaderDelay = setTimeout(() => {
        this.setState({ loading: true })
      }, 700)
      try {
        const results = await searchFn(phrase, 5)
        clearTimeout(loaderDelay)
        trackEvent('Search', 'Omni', '', '', {
          search_term: phrase
        })
        this.setState({ results, loading: false })
      } catch (e) {
        this.setState({
          results: [],
          loading: false,
          error: 'Please check your connection'
        })
      }
    } else {
      this.props.setSearchTerms(phrase)
      this.setState({ hidden: true, results: [] })
    }
  }

  // onKeyUp because onKeyPress does _not_ respond to ESC
  // https://stackoverflow.com/questions/37440408/how-to-detect-esc-key-press-in-react-and-how-to-handle-it#comment77751556_41797287
  onKeyUp({ key }) {
    switch (key) {
      case 'Enter':
        if (this.props.searchTerm.length > 0) this.onAllResultsClick()
        break
      case 'Escape':
        this.hideResults()
        break
    }
  }

  onClearInput() {
    this.props.clearSearchTerm()
    this.setState({ hidden: true })
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new Event(EVENTS.CONTENT.DIMMER_OFF))
    }
  }

  render() {
    const groups = this.state.results || {}
    const searchResults = Object.keys(groups).map((group, groupIndex) => {
      const results = groups[group]
      return (
        <div key={`sr:${group.label}:${groupIndex}`}>
          <SearchGroupHeading py={1} px={25} fontSize={0}>
            {group}
          </SearchGroupHeading>
          {results.map((result, i) => (
            <SearchResult
              onClick={this.onSearchItemClick}
              searchTerm={this.props.searchTerm}
              key={`${group}:${i}`}
              {...result}
            />
          ))}
        </div>
      )
    })

    const emptySearchTerm =
      !this.props.searchTerm || !this.props.searchTerm.length
    const clearSearchInput =
      this.state.hidden && emptySearchTerm ? null : (
        <IconCloseClear
          id="omni-search-clear-button"
          onClick={this.onClearInput}
        />
      )
    const loading = this.state.loading ? (
      <Loading>
        <Spinner alt="Finding results" />
      </Loading>
    ) : null
    return (
      <ContainerDivider>
        <MagnifyingGlass alt="Magnifying Glass" />
        <SearchInput
          autoComplete="off"
          placeholder="Type something to search"
          innerRef={(x) => (this.input = x)}
          aria-label="Site search"
          ref={(input) => (this.input = input)}
          onMouseEnter={this.onMouseEnter}
          onChange={this.onChange}
          onKeyUp={this.onKeyUp}
          value={this.props.searchTerm}
          id="omni-search-input"
        />
        {!this.props.minimal && clearSearchInput}
        <SearchResults hidden={this.state.hidden}>
          {this.state.error && (
            <ErrorFeedback>{this.state.error}</ErrorFeedback>
          )}
          {searchResults}
          {searchResults.length === 0 ? (
            <Feedback>No results found</Feedback>
          ) : (
            <ViewAllResultsButton onClick={this.onAllResultsClick} py={12}>
              View all results
            </ViewAllResultsButton>
          )}
          {loading}
        </SearchResults>
      </ContainerDivider>
    )
  }
}

export default HeaderOmniSearch
